// A reusable loading spinner component with consistent styling
import { cn } from "@/lib/utils"

export interface LoadingSpinnerProps {
    size?: "default" | "sm" | "lg"
    className?: string
}

export function LoadingSpinner({ size = "default", className }: LoadingSpinnerProps) {
    return (
        <div
            className={cn(
                "animate-spin rounded-full border-2 border-current border-t-transparent",
                size === "default" && "h-5 w-5",
                size === "sm" && "h-4 w-4",
                size === "lg" && "h-8 w-8",
                className
            )}
        />
    )
} 